import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {

  userDetails: [],
  userDataDetails: [],
  renewalDetails: [],
  usersDataList: [],
  accountId: '',
  groupUserIdData: [],
  groupRestrictedIdData: "",
  selectGroupData: [],
  usersIndexPermissionData: [],
  routerData: [],
  dummyOrderSubPlan: [],
  packageRouterDatas: [],
  customizeVouchersData: '',
  addUserDetails: [],
  editUserDetails: [],
  viewUserDetails: [],
  viewUsersList: [],
  viewAllUserDetails: [],
  viewALLUsersList: [],
  viewAllUserElasticDetails: [],
  viewALLUsersElasticList: [],
  userTrafficGraphsList: [],
  userTrafficGraphsPermission: [],
  userFupList: [],
  userFupPermission: [],
  userPhoneNumbersList: [],
  userDocumentsPermissions: [],
  userDocumentsList: [],
  userInventoryDetails: [],
  userLedgerList: [],
  userLedgerPermission: [],
  userFranchiseStatementList: [],
  userFranchiseStatementPermission: [],
  userPinsList: [],
  userPinsPermission: [],
  cafGenerationData: [],
  viewPinsList: [],
  viewPinsPermissions: [],
  userCommentsList: [],
  userCommentsPermission: [],
  userWebsiteLogsPermission: [],
  userWebsiteLogsList: [],
  userContactsList: [],
  userContactsPermission: [],
  userSetLocationList: [],
  userSetLocationPermission: [],
  userDevicesList: [],
  userOverrideBillingCycleList: [],
  viewUserReferralCodeList: [],
  viewUserOnuCpeDevicesList: [],
  generateMultipleUsersList: [],
  rejectedUsersList: [],
  presentSessionsDataList: [],
  pendingUsersList: [],
  pendingUsers: [],
  sideBarUsersList: [],
  importUsersData: [],
  usersCsvImportPercent: "",
  usersRenewPercent: "",
  expireDatePercent: "",

}

const mutations = {
  CLEAR_USER_DETAILS_STATE(state) {
    state.userDetails = [];
  },
  CLEAR_USER_STATE(state) {
    state.userDetails = [];
    state.userDataDetails = [];
    state.renewalDetails = [];
    state.usersDataList = [];
    state.accountId = '';
    state.groupUserIdData = [];
    state.groupRestrictedIdData = "";
    state.selectGroupData = [];
    state.usersIndexPermissionData = [];
    state.routerData = [];
    state.dummyOrderSubPlan = [];
    state.customizeVouchersData = '';
    state.addUserDetails = [];
    state.editUserDetails = [];
    state.viewAllUserDetails = [];
    state.viewALLUsersList = [];
    state.viewAllUserElasticDetails = [];
    state.viewALLUsersElasticList = [];
    state.userInventoryDetails = [];
  },
  SET_USER_PINS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.userPinsPermission = userData.permissions;
    state.userPinsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userPinsList'] = parseData;
      state.userPinsList = tData;
    }
  },
  SET_PRESENT_SESSIONS_DATE_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.presentSessionsDataList = [];
    if (parseData != null) {
      tData[userData.accountId + '-presentSessionsDataList'] = parseData;
      state.presentSessionsDataList = tData;
    }
  },
  SET_REJECTED_USERS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.rejectedUsersList = [];
    if (parseData != null) {
      tData[userData.accountId + '-rejectedUsersList'] = parseData;
      state.rejectedUsersList = tData;
    }
  },
  SET_PENDING_USERS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.pendingUsersList = [];
    if (parseData != null) {
      tData[userData.accountId + '-pendingUsersList'] = parseData;
      state.pendingUsersList = tData;
    }
  },
  SET_PENDING_USERS(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.pendingUsers = [];
    if (parseData != null) {
      tData[userData.accountId + '-pendingUsers'] = parseData;
      state.pendingUsers = tData;
    }
  },
  SET_USER_COMMENTS_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userCommentsPermission = userData.permissions;
    state.userCommentsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userCommentsList'] = parseData;
      state.userCommentsList = tData;
    }
  },
  SET_VIEW_USER_REFERRAL_CODE_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.viewUserReferralCodeList = [];
    if (parseData != null) {
      tData[userData.accountId + '-viewUserReferralCodeList'] = parseData;
      state.viewUserReferralCodeList = tData;
    }
  },
  SET_VIEW_USER_ONUCPE_DEVICES_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.viewUserOnuCpeDevicesList = [];
    if (parseData != null) {
      tData[userData.accountId + '-viewUserOnuCpeDevicesList'] = parseData;
      state.viewUserOnuCpeDevicesList = tData;
    }
  },
  SET_USER_WEBSITE_LOGS_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userWebsiteLogsPermission = userData.permissions;
    state.userWebsiteLogsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userWebsiteLogsList'] = parseData;
      state.userWebsiteLogsList = tData;
    }
  },
  SET_USER_CONTACTS_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userContactsPermission = userData.permissions;
    state.userContactsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userContactsList'] = parseData;
      state.userContactsList = tData;
    }
  },
  SET_USER_LOCATION_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userSetLocationPermission = userData.permissions;
    state.userSetLocationList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userSetLocationList'] = parseData;
      state.userSetLocationList = tData;
    }
  },
  SET_USER_DEVICES_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userDevicesList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userDevicesList'] = parseData;
      state.userDevicesList = tData;
    }
  },
  SET_USER_OVERRIDE_BILLING_CYCLE_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userOverrideBillingCycleList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userOverrideBillingCycleList'] = parseData;
      state.userOverrideBillingCycleList = tData;
    }
  },
  SET_GENERATE_MULTIPLE_USERS_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.generateMultipleUsersList = [];
    if (parseData != null) {
      tData[userData.accountId + '-generateMulitpleUsersList'] = parseData;
      state.generateMultipleUsersList = tData;
    }
  },
  SET_USER_FRANCHISE_STATEMENT_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.userFranchiseStatementPermission = userData.permissions;
    state.userFranchiseStatementList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userFranchiseStatementList'] = parseData;
      state.userFranchiseStatementList = tData;
    }
  },
  SET_USER_LEDGER_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userLedgerPermission = userData.permissions;
    state.userLedgerList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userLedgerList'] = parseData;
      state.userLedgerList = tData;
    }
  },
  SET_DOCUMENT_MANAGEMENT_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.userDocumentsPermissions = userData.permissions;
    state.userDocumentsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userDocumentsList'] = parseData;
      state.userDocumentsList = tData;
    }
  },
  SET_VIEW_PINS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.viewPinsPermissions = userData.permissions;
    state.viewPinsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-viewPinsList'] = parseData;
      state.viewPinsList = tData;
    }
  },
  SET_USER_TRAFFIC_GRAPHS_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userTrafficGraphsPermission = userData.permissions;
    state.userTrafficGraphsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userTrafficGraphsList'] = parseData;
      state.userTrafficGraphsList = tData;
    }
  },
  SET_PHONE_NUMBERS_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userPhoneNumbersList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userPhoneNumbersList'] = parseData;
      state.userPhoneNumbersList = tData;
    }
  },
  SAVE_PHONE_NUMBER_LIST(state, data) {
    var accountId = data.BlockedNumber.account_id;
    if (Object.keys(state.userPhoneNumbersList).length != 0) {
      if (data.BlockedNumber.type == "blocked") {
        state.userPhoneNumbersList[accountId + "-userPhoneNumbersList"].blockedPhoneNumbers.push(data);
      } else if (data.BlockedNumber.type == "autoLogin") {
        state.userPhoneNumbersList[accountId + "-userPhoneNumbersList"].withoutVerificationNumbers.push(data);
      }
    }
  },
  SET_USER_FUP_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userFupPermission = userData.permissions;
    state.userFupList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userFupList'] = parseData;
      state.userFupList = tData;
    }
  },
  SET_USER_DETAILS(state, userData) {
    var tData = {};
    var message = JSON.parse(userData.message);
    if (Object.keys(state.userDetails).length == 0) {
      tData[userData.accountId + '-' + userData.userId] = message;
      state.userDetails = tData;
    } else {
      Vue.set(state.userDetails, userData.accountId + '-' + userData.userId, message);

    }

  },
  SET_USER_DATA_DETAILS(state, userData) {
    var tData = {};
    state.userDataDetails = [];
    var message = JSON.parse(userData.message);
    tData[userData.accountId + '-' + userData.userId] = message;
    state.userDataDetails = tData;
  },
  SET_ADD_USER_DATA(state, userData) {
    state.addUserDetails = userData;
  },
  SET_EDIT_USER_DATA(state, userData) {
    state.editUserDetails = userData;
  },
  EDIT_USER_NAME(state, userName) {
    if (state.editUserDetails.userEditData != undefined && state.editUserDetails.userEditData.username != undefined) {
      Vue.set(state.editUserDetails.userEditData, 'username', userName);
    }
  },
  SET_RENEWAL_DETAILS(state, userData) {
    var tData = {};
    var message = JSON.parse(userData.message);
    if (Object.keys(state.userDetails).length == 0) {
      tData[userData.accountId] = message;
      state.renewalDetails = tData;
    } else {
      Vue.set(state.renewalDetails, userData.accountId, message);
    }

  },
  SET_FAILURE(state, error) {
    Nprogress.done();
    Vue.notify({
      group: 'foo',
      type: 'error',
      text: error
    });
  },
  SET_SUCCESS(state, error) {
    Nprogress.done();
    Vue.notify({
      group: 'foo',
      type: 'success',
      text: error
    });
  },
  UPDATE_PROFILE_PHOTO(state, data) {
    console.log('state  : ', state);
    var obj = Object.keys(state.userDataDetails);
    var dataobj = data.accountId + "-" + data.userId;
    if (obj.includes(dataobj) == true) {
      if (data.userProfile != '') {
        state.userDataDetails[dataobj].userProfileImage = data.cdnhost + "/" + data.accountId + "/img/users/" + data.userProfile;
      }
    }
  },
  UPDATE_SIGN_PHOTO(state, data) {
    console.log('state  : ', state);
    var obj = Object.keys(state.userDataDetails);
    var dataobj = data.accountId + "-" + data.userId;
    if (obj.includes(dataobj) == true) {
      if (data.userSign != '') {
        state.userDataDetails[dataobj].userSignImage = data.cdnhost + "/" + data.accountId + "/img/users/" + data.userSign;
      }
    }
  },
  UPDATE_COLLECT_GST(state, data) {
    var obj = Object.keys(state.userDetails);
    var dataobj = data.accountId + "-" + data.userId;
    if (obj.includes(dataobj) == true) {
      if (data.gstStartDate != '' && data.gstStartDate != undefined) {
        state.userDetails[dataobj].userGroupsData.gstStartDate = data.gstStartDate;
      }
      if (data.value != '' && data.value != undefined) {
        state.userDetails[dataobj].userGroupsData.collectPayment = data.value;
      }
    }
  },
  UPDATE_EXPIRY(state, userDetails) {
    for (var i = 0; i < userDetails.length; i++) {
      var obj = Object.keys(state.userDetails);
      var dataobj = userDetails[i].User.account_id + "-" + userDetails[i].User.id;
      if (obj.includes(dataobj) == true) {
        state.userDetails[dataobj].expirationTime = userDetails[i].expirationTime;
        state.userDetails[dataobj].userDetail = userDetails[i].User;
        state.userDetails[dataobj].userGroups = userDetails[i].userGroups;
        state.userDetails[dataobj].profiles = userDetails[i].profiles;
        if (userDetails[i].billingInfo != '' && userDetails[i].billingInfo != undefined) {
          state.userDetails[dataobj].billingInfo = userDetails[i].billingInfo;
        }
        if (userDetails[i].extendGrace != '' && userDetails[i].extendGrace != undefined) {
          state.userDetails[dataobj].extendGrace = userDetails[i].extendGrace;
        }
      }
      var obj1 = Object.keys(state.userDataDetails);
      if (obj1.includes(dataobj) == true) {
        state.userDataDetails[dataobj].expirationTime = userDetails[i].expirationTime;
        state.userDataDetails[dataobj].userDetails = userDetails[i].User;
        state.userDataDetails[dataobj].userGroups = userDetails[i].userGroups;
        state.userDataDetails[dataobj].profiles = userDetails[i].profiles;
        if (userDetails[i].extendGrace != '' && userDetails[i].extendGrace != undefined) {
          state.userDataDetails[dataobj].extendGrace = userDetails[i].extendGrace;
        }
      }
    }
  },
  DELETE_SCHEDULE(state, postData) {
    var obj = Object.keys(state.userDetails);
    var dataobj = postData.accountId + "-" + postData.userId;
    if (obj.includes(dataobj) == true) {
      if (postData.param == 'scheduledRenewal') {
        state.userDetails[dataobj].scheduledRenewal = '';
      } else if (postData.param == 'gracePeriod') {
        state.userDetails[dataobj].gracePeriod = '';
      } else if (postData.param == 'discountUsers') {
        state.userDetails[dataobj].discountUsers = '';
      } else if (postData.param == 'extendGrace') {
        state.userDetails[dataobj].extendGrace = '';
      } else if (postData.param == 'moveUserCheckingoptions') {
        state.userDetails[dataobj].moveUserCheckingoptions = '';
      } else if (postData.param == 'userTerminate') {
        state.userDetails[dataobj].userTerminate = '';
      } else if (postData.param == 'ismicrotikIP') {
        state.userDetails[dataobj].ismicrotikIP = '';
      }
    }
  },
  SET_USERSDATA_LIST(state, usersDataList) {
    var tData = {};
    var parseData = JSON.parse(usersDataList);
    tData.account_id = parseData.account_id;
    if (parseData > 0 || parseData != null) {
      state.accountId = parseData.account_id;
      if (Object.keys(state.usersDataList).length == 0) {
        tData[parseData.account_id + '-usersDataList'] = parseData;
        state.usersDataList = tData;
      } else {
        tData[parseData.account_id + '-usersDataList'] = parseData;
        state.usersDataList = tData;
      }
    }
  },
  DELETE_USERDATA_LIST(state, userData) {
    if (Object.keys(state.usersDataList).length != 0) {
      var index = state.usersDataList[state.accountId + "-usersDataList"].userGroupId.findIndex(userd => userd.id == userData.ids);
      state.usersDataList[state.accountId + "-usersDataList"].userGroupId.splice(index, 1)
    }
  },
  DELETE_USER_WEBSITE_LOGS(state, userData) {
    if (Object.keys(state.userWebsiteLogsList).length != 0) {
      for (var i = 0; i < userData.fileName.length; i++) {
        var index = state.userWebsiteLogsList[userData.accountId + "-userWebsiteLogsList"].files.findIndex(webLogs => webLogs == userData.fileName[i]);
        state.userWebsiteLogsList[userData.accountId + "-userWebsiteLogsList"].files.splice(index, 1)
      }
    }
  },
  APPROVE_USER_LIST(state, userData) {
    if (Object.keys(state.pendingUsersList).length != 0) {
      if (userData.userId.length > 0) {
        for (var i = 0; i < userData.userId.length; i++) {
          var index = state.pendingUsersList[userData.accountId + "-pendingUsersList"].findIndex(approveUsers => approveUsers.User.id == userData.userId[i]);
          if (index != '-1') {
            state.pendingUsersList[userData.accountId + "-pendingUsersList"].splice(index, 1)
          }
        }
      } else {
        var index = state.pendingUsersList[userData.accountId + "-pendingUsersList"].findIndex(approveUsers => approveUsers.User.id == userData.userId);
        if (index != '-1') {
          state.pendingUsersList[userData.accountId + "-pendingUsersList"].splice(index, 1)
        }
      }
    }
  },
  ADD_USER_CONTACTS_LOGS(state, userContact) {
    var newUserContact = userContact;
    var accountId = userContact.UserContact.account_id;
    if (Object.keys(state.userContactsList).length != 0) {
      state.userContactsList[accountId + "-userContactsList"].details.unshift(newUserContact);
    }
  },
  UPDATE_USER_CONTACTS_LOGS(state, userContact) {
    var accountId = userContact.UserContact.account_id;
    if (Object.keys(state.userContactsList).length != 0) {
      var index = state.userContactsList[accountId + "-userContactsList"].details.findIndex(contacts => contacts.UserContact.id == userContact.UserContact.id);
      if (index != '-1') {
        state.userContactsList[accountId + "-userContactsList"].details[index].UserContact.description = userContact.UserContact.description;
        state.userContactsList[accountId + "-userContactsList"].details[index].UserContact.designation = userContact.UserContact.designation;
        state.userContactsList[accountId + "-userContactsList"].details[index].UserContact.email_id = userContact.UserContact.email_id;
        state.userContactsList[accountId + "-userContactsList"].details[index].UserContact.name = userContact.UserContact.name;
        state.userContactsList[accountId + "-userContactsList"].details[index].UserContact.phone_number = userContact.UserContact.phone_number;
      }
    }
  },
  DELETE_USER_CONTACTS_LOGS(state, userData) {
    if (Object.keys(state.userContactsList).length != 0) {
      var index = state.userContactsList[userData.accountId + "-userContactsList"].details.findIndex(contacts => contacts.UserContact.id == userData.deletedContact);
      if (index != '-1') {
        state.userContactsList[userData.accountId + "-userContactsList"].details.splice(index, 1)
      }
    }
  },
  DELETE_ALL_CONTACTS_LOGS(state, userData) {
    if (Object.keys(state.userContactsList).length != 0) {
      for (var i = 0; i < userData.deletedContactList.length; i++) {
        var index = state.userContactsList[userData.accountId + "-userContactsList"].details.findIndex(contacts => contacts.UserContact.id == userData.deletedContactList[i]);
        if (index != '-1') {
          state.userContactsList[userData.accountId + "-userContactsList"].details.splice(index, 1)
        }
      }
    }
  },
  DELETE_ALL_USER_GROUP(state, userData) {
    var newData = userData.data;
    state.usersDataList[state.accountId + "-usersDataList"].userGroupId = newData;
  },
  SET_GROUPID_CHANGE(state, userData) {
    state.groupUserIdData = userData;
  },
  SET_RESTRICTED_GROUPID(state, userData) {
    state.groupRestrictedIdData = userData;
  },
  ADD_USER_GROUP(state, userData) {
    var tData = {};
    var parseData = userData.groupdata;
    tData.account_id = userData.accountId;
    if (parseData != null) {
      state.accountId = parseData.account_id;
      if (Object.keys(state.usersDataList).length == 0) {
        tData[tData.account_id + '-usersDataList'] = parseData;
        state.usersDataList = tData;
      } else {
        tData[tData.account_id + '-usersDataList'] = parseData;
        state.usersDataList = tData;
      }
    }
  },
  ADD_USER_COMMENT_LIST(state, newUserComment) {
    var accountId = newUserComment.postDataAccount;
    if (Object.keys(state.userCommentsList).length != 0) {
      state.userCommentsList[accountId + "-userCommentsList"].userComment.unshift(newUserComment.newComment);
    }
  },
  EDIT_USER_GROUP(state, userData) {
    var newData = userData.groupdata;
    state.routerData = userData.groupdata[0].routeArr;
    for (var i = 0; i < newData.length; i++) {
      var index = state.usersDataList[userData.accountId + "-usersDataList"].userGroupId.findIndex(bandwidthd => bandwidthd.UserGroup.id == newData[i].UserGroup.id);
      if (index != '-1') {
        state.usersDataList[userData.accountId + "-usersDataList"].userGroupId.splice(index, 1)
      }
      state.usersDataList[userData.accountId + "-usersDataList"].userGroupId.push(newData[i]);
    }
  },
  SET_PACKAGEROUTER_DATA(state, data) {
    state.packageRouterDatas = data;
  },
  SET_SELECTGROUP_DATA(state, data) {
    state.selectGroupData = data;
  },
  SET_USERSINDEX_PERMISSION(state, data) {
    state.usersIndexPermissionData = data;
  },
  CHANGE_ROUTER_GROUPS(state, data) {
    state.routerData = data.routerAr;
  },
  SET_SUBPLAN_DATAS(state, data) {
    state.dummyOrderSubPlan = data;
  },
  SET_CUSTOMIZE_VOUCHERS_DATA(state, data) {
    state.customizeVouchersData = data;
  },
  SET_VIEW_USERS_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.viewUserDetails = new Array();
    if (parseData != null) {
      tData['viewUsersDetails'] = parseData;
      state.viewUserDetails = tData;
    }
  },
  SET_VIEW_USERS_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.viewUsersList = new Array();
    if (parseData != null) {
      tData['usersList'] = parseData;
      state.viewUsersList = tData;
    }
  },
  SET_VIEW_ALL_USERS_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.viewAllUserDetails = new Array();
    if (parseData != null) {
      tData['viewAllUsersDetails'] = parseData;
      state.viewAllUserDetails = tData;
    }
  },
  SET_VIEW_ALL_USERS_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = JSON.parse(data.message);
    state.viewALLUsersList = new Array();
    if (parseData != null) {
      tData['allUsersList'] = parseData;
      state.viewALLUsersList = tData;
    }
  },
  SET_VIEW_ALL_USERS_ELASTIC_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.viewAllUserElasticDetails = new Array();
    if (parseData != null) {
      tData['viewAllUsersDetails'] = parseData;
      state.viewAllUserElasticDetails = tData;
    }
  },
  SET_VIEW_ALL_USERS_ELASTIC_TABLE_LIST(state, data) {
    var tData = {};
    var parseData = data.aaData;
    state.viewALLUsersElasticList = new Array();
    if (parseData != null) {
      tData['allUsersList'] = parseData;
      state.viewALLUsersElasticList = tData;
    }
  },
  SET_USER_INVENTORY_DATA(state, data) {
    var tData = {};
    var parseData = data.message;
    state.userInventoryDetails = new Array();
    if (parseData != null) {
      tData['inventoryDetailsDetails'] = parseData;
      state.userInventoryDetails = tData;
    }
  },
  SUBMIT_INVENTORY_RETURN_FORM(state, userData) {
    var newData = userData.data;
    var index = state.userInventoryDetails["inventoryDetailsDetails"].inventoryDetails.findIndex(inv => inv.InventoryItemTransfer.id == newData);
    if (index != '-1') {
      state.userInventoryDetails["inventoryDetailsDetails"].inventoryDetails.splice(index, 1)
    }
  },
  SET_CAF_GENERATION_DATA(state, data) {
    state.cafGenerationData = data
  },
  CLEAR_VIEW_USER_STATE(state, data) {
    state.viewUserDetails = []
    state.viewUsersList = []
  },
  ADD_USER_TO_SIDEBAR(state, data) {
    console.log("sidebar_commit", data);
    if (state.sideBarUsersList.length > 0) {
      const index = state.sideBarUsersList.findIndex(e => e.userId == data.userId && e.accountId == data.accountId)
      if (index == -1) {
        state.sideBarUsersList.push(data);
      }
    } else {
      state.sideBarUsersList.push(data);
    }
  },
  DELETE_USER_TO_SIDEBAR(state, data) {
    if (state.sideBarUsersList.length > 1) {
      const index = state.sideBarUsersList.findIndex(e => e.userId == data.userId && e.accountId == data.accountId)
      if (index != -1) {
        state.sideBarUsersList.splice(index, 1)
      }
    }
  },
  CLEAR_USER_TO_SIDEBAR(state, data) {
    state.sideBarUsersList = []
  },
  SET_IMPORT_USERS_DATA(state, data) {
    state.importUsersData = data
  },
  DELETE_USER_DEVICE_LIST(state, data) {
    var usrId = data.devId;
    var accountId = data.accountId;
    if (Object.keys(state.userDevicesList).length != 0) {
      var index = state.userDevicesList[accountId + "-userDevicesList"].userDevices.findIndex(usr => usr.OneSignalUsers.id == usrId);
      if (index != -1) {
        state.userDevicesList[accountId + "-userDevicesList"].userDevices.splice(index, 1);
      }
    }
  },
  UPDATE_FREEZE_STATE(state, data) {
    var userId = data.userId;
    var accountId = data.accountId;
    if (data.freezeType == 'indefinite') {
      var parseData = 'definite';
    } else if (data.freezeType == 'definite') {
      var parseData = 'indefinite';
    }
    if (Object.keys(state.userDetails).length != 0) {
      if (parseData != null) {
        //     tData['freeze_value'] = parseData;
        state.userDetails[accountId + "-" + userId].freeze_value = parseData;
        if (parseData == 'indefinite') {
          state.userDetails[accountId + "-" + userId].userDetail.status = 'frozen';
        } else if (parseData == 'definite') {
          state.userDetails[accountId + "-" + userId].userDetail.status = 'active';
        }
      }
    }
  },
  SOCKET_USERSIMPORTPROGRESSDATA(state, data) {
    state.usersCsvImportPercent = data
  },
  SOCKET_RENEWPERCENTAGE(state, data) {
    state.usersRenewPercent = data
  },
  SOCKET_EXPIREDATEPERCENTAGE(state, data) {
    state.expireDatePercent = data
  }
}

const actions = {
  addUsersTosideBar({
    commit,
    dispatch
  }, postData) {
    commit("ADD_USER_TO_SIDEBAR", postData)
  },
  clearSideUsersState({
    commit,
    dispatch
  }, postData) {
    commit("CLEAR_USER_TO_SIDEBAR", postData)
  },
  deleteSideBarUsers({
    commit,
    dispatch
  }, postData) {
    commit("DELETE_USER_TO_SIDEBAR", postData)
  },
  clearViewUsersState({
    commit,
    dispatch
  }, postData) {
    commit('CLEAR_VIEW_USER_STATE')
  },
  getPinDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/get_pin_details.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getInvoiceDetail({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getInvoiceDetails/franchise', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getUserTrafficUsageDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/user_traffic_usage/' + authData.userId + '/' + authData.accountId + '/true')
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_TRAFFIC_GRAPHS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  getUserFupDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/fup/' + authData.userId + '/' + authData.accountId + '/true')
        .then(res => {
          Nprogress.done()
          commit('SET_USER_FUP_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getFupTemplateDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/getFupTemplateDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createBillForRecurringOrder({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/create_order_from_bill_Plan', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchSubPlans({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/getSubPlans', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchSubPlanDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/getSubPlanDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  submitOneTimeModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/separateBillForOtherOrder', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  savePhoneNumbersSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/save_phone_numbers', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('SAVE_PHONE_NUMBER_LIST', response.data.blockListNumberDetails)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createNewTemplateSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/save_fup', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getUserLedgerDetailsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/user_ledger/' + authData.userId + "/" + authData.accountId + "/true" + "/" + authData.fromDate + "/" + authData.toDate)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_LEDGER_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  exportLedgerPdfDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/export_ledger_pdf', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            return;
          }
          window.open("/backend" + response.data.message);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  mailLedgerDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/mail_ledger', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  saveEditedValueDetailsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/edit_pending_field', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  approveUserDetailsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/approve_user.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('APPROVE_USER_LIST', postData);
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  rejectUserSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/reject_user.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchPendingUsersDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/pending_users_data/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          commit('SET_PENDING_USERS_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchPresentSessionsDataDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/present_sessions_date/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          commit('SET_PRESENT_SESSIONS_DATE_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchRejectedUsersDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/rejected_users_data/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          commit('SET_REJECTED_USERS_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserPinsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/view_user_pins/' + authData.userId + '/' + authData.accountId + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          commit('SET_USER_PINS_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserCommentsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/comments/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_COMMENTS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchViewUserReferralCodeList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/view_user_referral_code/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          commit('SET_VIEW_USER_REFERRAL_CODE_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchViewUserOnuCpeDevicesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/view_user_onucpe_devices/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          commit('SET_VIEW_USER_ONUCPE_DEVICES_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserWebsiteLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/website_logs/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_WEBSITE_LOGS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserContactsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/user_contacts/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_CONTACTS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserSetLocationList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/set_location/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          commit('SET_USER_LOCATION_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchStreetList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_street/' + authData.areaId + '/' + authData.accountId)
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchBlockList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_block' + authData.streetId + '/' + authData.userId + '/' + authData.accountId)
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchStreetList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_street/' + authData.areaId + '/' + authData.accountId)
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserDevicesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/user_devices/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_DEVICES_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  revertUserSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/revert_user.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  deleteUserSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_users.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  saveDisableAutoLogin({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/save_disable_autologin', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  fetchUserOverrideBillingCycleList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/override_billing_cycle/' + authData.userId + '/' + authData.accountId + "/true")
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_OVERRIDE_BILLING_CYCLE_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchGenerateMultipleUsersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/add_bulk/' + authData.userId + '/true')
        .then(res => {
          Nprogress.done()
          commit('SET_GENERATE_MULTIPLE_USERS_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  overrideBillingCycleSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/callingPostMethodOfOverrideBillingCycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  addBulkUsersSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_bulk', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  fetchUserFranchiseStatementsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/franchiseStatementData/' + authData.userId + '/' + authData.accountId + '/' + authData.customDateFrom + "/" + authData.customDateTo + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          commit('SET_USER_FRANCHISE_STATEMENT_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUsersDocumentsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/user_documents_data/' + authData.accountId + "/" + authData.status + "/" + authData.customDateFrom + "/" + authData.customDateTo + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting + '/' + authData.exportData)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            resolve(res.data);
            if (authData.exportData != 'yes') {
              commit('SET_DOCUMENT_MANAGEMENT_LIST', res.data)
            }
          }
        })
        .catch(error => console.log(error))
    });
  }, deleteUserProfileImage({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_profile_image', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  deleteUserSignImage({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_sign_image', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  addCommentSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_comments', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            newComment: response.data.newComment,
            postDataAccount: postData.postAccountId
          }
          commit('ADD_USER_COMMENT_LIST', data)
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  addUserReferralCodeSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_user_referal_code', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  unlinkOnuSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/access_points/unlink_onu', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  uploadUserProfilePicture({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios
        .post("/users/upload_user_profile_image", postData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
          commit('UPDATE_PROFILE_PHOTO', response.data)

        })
        .catch(error => console.log(error));
    });
  },
  uploadUserSignPicture({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios
        .post("/users/upload_user_sign_image", postData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
          commit('UPDATE_SIGN_PHOTO', response.data)
        })
        .catch(error => console.log(error));
    });
  },
  fetchUserDetails({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      if (!authData.hasOwnProperty("load")) {
        Nprogress.start()
      }
      var id = authData.userId;
      var accountId = authData.accountId;
      axios.get('/users/user_stats_data/' + id + '/' + accountId)
        .then(res => {
          if (!authData.hasOwnProperty("load")) {
            Nprogress.done()
          }

          commit('SET_USER_DETAILS', res.data)
          resolve(res.data);

        })
        .catch(error => console.log(error))
    });
  }, fetchUserDataDetails({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      if (!authData.hasOwnProperty("load")) {
        Nprogress.start()
      }
      var id = authData.userId;
      var accountId = authData.accountId;
      axios.get('/users/details/' + id + '/' + accountId + '/' + true)
        .then(res => {
          if (!authData.hasOwnProperty("load")) {
            Nprogress.done()
          }

          commit('SET_USER_DATA_DETAILS', res.data)
          resolve(res.data);

        })
        .catch(error => console.log(error))
    });
  },
  fetchViewPinsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/pin_billing/view_pin_data/' + authData.pinGroupId + "/" + true + "/" + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          resolve(res.data);
          commit('SET_VIEW_PINS_LIST', res.data)
        })
        .catch(error => console.log(error))
    });
  },
  fetchAddUserData({
    commit,
  }, groupId) {
    Nprogress.start()
    axios.get('/users/add/' + groupId + '/true')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_ADD_USER_DATA', res.data.message);
        }

      })
      .catch(error => console.log(error))
  },
  fetchEditUserData({
    commit,
  }, getData) {
    Nprogress.start()
    axios.get('/users/edit/' + getData.userId + '/' + getData.accountId + '/true')
      .then(res => {
        Nprogress.done()
        commit('SET_EDIT_USER_DATA', res.data.message);
      })
      .catch(error => console.log(error))
  },
  fetchRenewalDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    var id = authData.userId;
    var accountId = authData.accountId;
    axios.get('/users/franchise_renew_option/' + accountId)
      .then(res => {
        Nprogress.done()

        commit('SET_RENEWAL_DETAILS', res.data)

      })
      .catch(error => console.log(error))
  },
  errorMessage({
    commit,
    dispatch
  }, error) {
    commit('SET_FAILURE', error);
  },
  successMessage({
    commit,
    dispatch
  }, error) {
    commit('SET_SUCCESS', error);
  },
  removeScheduleRenewal({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        userId: authData.userId,
        accountId: authData.accountId,
        attribute: 'scheduleRenewal'
      }
      axios.post('/users/remove_schedule', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          postData.param = 'scheduledRenewal';
          commit('DELETE_SCHEDULE', postData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  removeGracePeriod({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        userId: authData.userId,
        accountId: authData.accountId
      }
      axios.post('/users/delete_payAsYouGo_grace_period', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          postData.param = 'gracePeriod';
          commit('DELETE_SCHEDULE', postData);
          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  removeDiscountSchedule({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        userId: authData.userId,
        accountId: authData.accountId,
        discountId: authData.discountId
      }
      axios.post('/users/delete_scheduled_discount', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          postData.param = 'discountUsers';
          commit('DELETE_SCHEDULE', postData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  deleteAdditionalDaysSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        userId: authData.userId,
        accountId: authData.accountId
      }
      axios.post('/users/delete_additional_grace_period', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          postData.param = 'extendGrace';
          commit('DELETE_SCHEDULE', postData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  removeScheduleSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        userId: authData.userId,
        accountId: authData.accountId,
        attribute: authData.attribute
      }
      axios.post('/users/remove_schedule', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (postData.attribute == 'moveUser') {
            postData.param = 'moveUserCheckingoptions';
          } else {
            postData.param = 'userTerminate';
          }
          commit('DELETE_SCHEDULE', postData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  resetCounterSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        userId: authData.userId,
        accountId: authData.accountId
      }
      axios.post('/users/reset_counter', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  removehostsSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        Id: authData.userId,
        accountId: authData.accountId,
        Ip: authData.Ip
      }
      axios.post('/users/removeHost', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          postData.param = 'ismicrotikIP';
          commit('DELETE_SCHEDULE', postData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  removeIpMacSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        accountId: authData.accountId,
        userId: authData.userId,
        Value: authData.Value,
        Checked: authData.Checked
      }
      axios.post('/users/release_ipmac', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  extendGraceModalSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = {
        userId: authData.userId,
        accountId: authData.accountId,
        extendsBasedOn: authData.extendsBasedOn,
        daysExtend: authData.daysExtend,
        expiresOn: authData.expiresOn
      }
      axios.post('/users/additional_grace_period', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  extendGraceUserModalSubmit(context, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/billing/extend', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          // for (var i = 0; i < response.data.userDetails.length; i++) {
          //   var index = context.rootState.billing.gracePeriodList[authData.accountId + "-gracePeriodList"].findIndex(voucher => voucher.User.id == response.data.userDetails[i].User.id);
          //   if (index != '-1') {
          //     context.rootState.billing.gracePeriodList[authData.accountId + "-gracePeriodList"][index].User = response.data.userDetails[i].User;
          //   }
          // }
          // context.commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  freezeModalSubmit({
    commit,
    dispatch
  }, authData) {
    // freezeModalSubmit(context, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/billing/freezeUser', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_FREEZE_STATE', authData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  releaseFreezeModalSubmit({
    commit,
    dispatch
  }, authData) {
    // releaseFreezeModalSubmit(context, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/billing/releaseFrozenUser', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_FREEZE_STATE', authData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  extendRevertModalSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/billing/revert', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          state.idAdminDetails = [],
            commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  moveGroupuser({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/move_user_group.json', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  moveUserAccount({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/users/moveUserSubAccounts.json', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  deleteUser({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/users/delete_users.json', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  clearUserBilling({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/clear_billing', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  resetUserPassword({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/reset_user_password.json', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  gstApplicableForm({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/users/save_gst_start_date', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_COLLECT_GST', authData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  collectPaymentForm({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/users/request_collect_payment', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          commit('UPDATE_COLLECT_GST', authData);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  terminateUserSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/users/terminate_user', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  reactivateUserSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/users/reactivate_user', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  }, applyDiscountToUser({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/apply_discount_to_users.json', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  }, sendSMS({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/sms_template_content', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  }, sendWhatsapp({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/whatsapp_template_content', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  sendEmail({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/email_template_content', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  }, extendRenewModalSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      // axios.post('/billing/renew_user', qs.stringify(authData, {
      //   parseArrays: false
      // }))
      axios.post('/billing/renew_user', authData)
        .then(response => {
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          commit('UPDATE_EXPIRY', response.data.userDetails);
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  fetchUsersData({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/users/users_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_USERSDATA_LIST', res.data.message)
          commit('SET_PACKAGEROUTER_DATA', res.data);
          commit('SET_USERSINDEX_PERMISSION', res.data.permission)
        }
        // commit('SET_USERDATAGROUPID_LIST', res.data.message)
      })
      .catch(error => console.log(error))
  },
  clearUsersState({
    commit,
    dispatch
  }) {
    commit('CLEAR_USER_STATE')
  },
  clearUsersDetailsState({
    commit,
    dispatch
  }) {
    commit('CLEAR_USER_DETAILS_STATE')
  },
  exportUserData({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/export', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status == "success") {
            window.open("/backend" + response.data.message, "_blank");
          } else {
            console.log("error from backend");
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteUsersData({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_group.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: postData.groupId,
            accountId: response.data.accountId
          }
          commit('DELETE_USERDATA_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getGroupIdData({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/groupChangeRestrictedGroups', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != "success") {
            reject(response.data.message);
            return;
          }

          commit('SET_GROUPID_CHANGE', response.data.message);
          commit('SET_RESTRICTED_GROUPID', response.data.GroupId);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  removeIpAuth({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/removeIpAuth', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  syncStaticQueue({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/syncQueueTree', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  releaseIpMacUser({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      if (postData.hasOwnProperty("Value")) {
        var url = '/users/release_ipmac.json';
      } else {
        var url = '/users/removeIpMac';
      }
      axios.post(url, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createDummyOrderSingle({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/create_dummy_orders_group', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addUserGroup({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/user_groups/add_user_group.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            groupdata: response.data.newdata,
            accountId: response.data.newdata.account_id
          }
          commit("ADD_USER_GROUP", dataList);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  editUserGroup({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/edit_group.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            groupdata: response.data.newData,
            accountId: response.data.newData[0].UserGroup.account_id
          }
          if (postData.method != 'edit') {
            commit("EDIT_USER_GROUP", dataList);
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  activeAllUsers({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/activateAllUsers')
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  suspendAllUsers({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/suspendAllUnpaidUsers')
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  removeIpAuthAllUsers({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/removeIpAuth')
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createGroupPackages({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/createGroupsForProfiles')
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  connectRouterGroup({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/connectRouterToAllGroups', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit("CHANGE_ROUTER_GROUPS", response.data.newData)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  restrictedGroupChangeForUser({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/group_change_restricted', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteAllGroupData({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_all_groups.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          console.log(response)
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            data: response.data.newData,
            accountId: response.data.newData[0].account_id
          }
          commit("DELETE_ALL_USER_GROUP", successData)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getValueForSelectGroup({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/get_add_or_remove_restricted_groups', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          console.log(response)
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('SET_SELECTGROUP_DATA', response.data.message)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getSubPlanDatas({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/get_current_profile_plans', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit("SET_SUBPLAN_DATAS", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  submitRestrictedGroupChangeAll({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_or_remove_restricted_group_change', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  customizeVouchers({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/customize_vouchers_list')
        .then(response => {
          loader.hide()
          if (response.data.status == "redirect") {
            router.push(response.data.message);
          } else {
            commit("SET_CUSTOMIZE_VOUCHERS_DATA", response.data);
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getPhoneNumbersDataList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/users/phone_numbers/true')
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data);
            return;
          }
          commit("SET_PHONE_NUMBERS_LIST", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  editUserNameSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/change_username', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit("EDIT_USER_NAME", postData.newUserNameValue);
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },

  addUserSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add', postData.formData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success' && response.data.status != 'other') {
            if (response.data.status == 'pending') {
              reject(response.data.genericBody);
            } else {
              reject(response.data.message);
            }
            return;
          }
          if (response.data.status == 'other') {
            var successData = {
              userId: response.data.userId,
              accountId: postData.account
            }
          } else {
            var successData = {
              userId: response.data.message.userId,
              accountId: postData.account
            }
          }

          resolve(successData);
        })
        .catch(error => console.log(error));
    });
  },

  editUserSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/edit', postData.formData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            if (response.data.status == 'pending') {
              reject(response.data.genericBody);
            } else {
              reject(response.data.message);
            }
            return;
          }
          var successData = {
            userId: response.data.message.userId,
            accountId: postData.account
          }
          resolve(successData);
        })
        .catch(error => console.log(error));
    });
  },

  leadActivationSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/lead_management/activateUser', postData.formData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.message.type == 'user') {
            var successData = {
              userId: response.data.message.userId,
              accountId: postData.account
            }
            resolve(successData);
          } else {
            resolve("Success");
          }
        })
        .catch(error => console.log(error));
    });
  },
  fetchViewUsersList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/users/view/' + postData + '/true')
        .then(response => {
          loader.hide()
          if (response.data.status == "redirect") {
            router.push(response.data.message);
          } else {
            commit("SET_VIEW_USERS_DATA", response.data);
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchViewUsersTableList({
    commit,
    dispatch
  }, postData) {
    if (postData.load == true) {
      Nprogress.start()
    }
    return new Promise((resolve, reject) => {
      axios.post('/vouchers/view_data/' + postData.userGroupId, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          if (postData.load == true) {
            Nprogress.done()
          }
          commit('SET_VIEW_USERS_TABLE_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  assignTasksData({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/tasks/assign_variables', postData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  getTaskUploadFileName({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/uploadUserProofs', postData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserDetailsForRaiseTickets({
    commit,
    dispatch
  }, postData) {
    if (postData.load == true) {
      Nprogress.start()
    }
    return new Promise((resolve, reject) => {
      axios.post('/helpdesk/getUsers/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getUserTypesRaiseTickets({
    commit,
    dispatch
  }, postData) {
    if (postData.load == true) {
      Nprogress.start()
    }
    return new Promise((resolve, reject) => {
      axios.post('/helpdesk/getTypes', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchViewAllUsersList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/users/all/' + null + '/all/true')
        .then(response => {
          loader.hide()
          if (response.data.status == "redirect") {
            router.push(response.data.message);
          } else {
            commit("SET_VIEW_ALL_USERS_DATA", response.data);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  fetchViewAllUsersTableList({
    commit,
    dispatch
  }, postData) {
    if (postData.load == true) {
      Nprogress.start()
    }
    return new Promise((resolve, reject) => {
      axios.post('/users/view_all_data/', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          if (postData.load == true) {
            Nprogress.done()
          }
          if (postData.export == true) {
            if (res.data.status == "success") {
              window.open("/backend" + res.data.message, "_blank");
              window.focus();
            }
            return;
          }
          commit('SET_VIEW_ALL_USERS_TABLE_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  payAsYouGoUser({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/users/enable_user_payAsYouGo', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  fetchViewAllUsersElasticList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/users/getallusers/' + postData.account + '/' + postData.status + '/' + null + '/' + null + '/true')
        .then(response => {
          loader.hide()
          if (response.data.status == "redirect") {
            router.push(response.data.message);
          } else {
            commit("SET_VIEW_ALL_USERS_ELASTIC_DATA", response.data);
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  blockOrUnblockUser({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/block_users.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  fetchViewAllUsersElasticTableList({
    commit,
    dispatch
  }, postData) {
    if (postData.load == true) {
      Nprogress.start()
    }
    return new Promise((resolve, reject) => {
      axios.post('/users/get_all_data/', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          if (postData.load == true) {
            Nprogress.done()
          }
          if (postData.export == true) {
            if (res.data.status == "success") {
              window.open("/backend" + res.data.message, "_blank");
              window.focus();
            }
            return;
          }
          commit('SET_VIEW_ALL_USERS_ELASTIC_TABLE_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  syncUserOnElasticSearch({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post("/users/sync_user_on_elastic_search", qs.stringify(postData, {
        parseArrays: false,
      }))
        .then((response) => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  getIpDetails({
    commit,
    dispatch
  }, postData) {
    let loader = Vue.$loading.show({
      canCancel: false,
    });
    return new Promise((resolve, reject) => {
      axios.post('/users/get_user_ip_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide()
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  arPingSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/arPing.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
          console.log(error);
        });
    });
  },
  userTicketsHelpDeskData({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {
      axios.post('/helpdesk/all_tickets_data/', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  searchUserData({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/search_users_list')
        .then(res => {
          Nprogress.done()
          if (res.data.response.status == "redirect") {
            router.push(res.data.response.message);
          } else {
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  searchUserDatawithQuery({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {
      axios.post('/users/getUserDetailsBasedOnSearching/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          if(res.data.status == "error"){
            reject(res.data.message);
            return;
          }
          resolve(res.data.json);
        })
        .catch(error => console.log(error))
    });
  },
  searchUserDatawithQuerywithtype({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/getUserDetailsBasedOnType', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide();
          if (res.data.status == 'success') {
            resolve(res.data);
          } else {
            reject(res.data)
          }
        })
        .catch(error => console.log(error))
    });
  },
  searchNatLogDatawithQuerywithtype({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/getNatLogDataBasedOnType', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide();
          if (res.data.status == 'success') {
            resolve(res.data);
          } else {
            reject(res.data)
          }
        })
        .catch(error => console.log(error))
    });
  },
  chechUserWithAccessPoint({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/chechUserWithAccessPoint', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide();
          if (res.data.status == 'success') {
            resolve(res.data);
          } else {
            reject(res.data)
          }
        })
        .catch(error => console.log(error))
    });
  },
  downloadNatLogDatawithQuery({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/downloadNatLogData', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          loader.hide();
          if (res.data.status == 'success') {
            resolve(res.data);
          } else {
            reject(res.data)
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserInventoryList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/users/inventory_details/' + postData.userId + '/' + postData.accountId + '/true')
        .then(response => {
          loader.hide()
          if (response.data.status == "redirect") {
            router.push(response.data.message);
          } else {
            commit("SET_USER_INVENTORY_DATA", response.data);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  submitReturnItemForm({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/inventoryReturnOrder', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          console.log(response)
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            data: postData.inId,
          }
          commit("SUBMIT_INVENTORY_RETURN_FORM", successData)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchCAFGenerationList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/caf_generation_list')
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_CAF_GENERATION_DATA', res.data)
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getCafGenerateUserDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/cafUserDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          console.log(response)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  downloadCafGenerationUsers({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      // axios.post('/users/download_caf', qs.stringify(postData, {
      //   parseArrays: false
      // }))
      axios.post('/users/download_caf', postData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(response => {
          loader.hide()
          if (response.data.status == "success") {
            window.open("/backend" + response.data.message, "_blank");
          } else {
            console.log("error from backend");
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  downloadWebsiteLogsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/captive_portal_settings/download_website_logs', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          window.open("/backend" + response.data.message);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteWebsiteLogsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/captive_portal_settings/delete_website_logs', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            accountId: postData.accountId,
            fileName: postData.fileName
          }
          commit('DELETE_USER_WEBSITE_LOGS', data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteContactsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_contacts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            accountId: postData.accountId,
            deletedContact: response.data.deletedContact
          }
          commit('DELETE_USER_CONTACTS_LOGS', data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteAllContactsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_all_contacts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            accountId: postData.accountId,
            deletedContactList: response.data.deletedContactList
          }
          commit('DELETE_ALL_CONTACTS_LOGS', data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditContactModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      if (postData.type == 'add') {
        axios.post('/users/add_contacts', qs.stringify(postData, {
          parseArrays: false
        }))
          .then(response => {
            loader.hide()
            if (response.data.status != 'success') {
              reject(response.data.message);
              return;
            }
            commit('ADD_USER_CONTACTS_LOGS', response.data.newContact);
            resolve(response.data);
          })
          .catch(error => console.log(error));
      } else if (postData.type == 'edit') {
        axios.post('/users/edit_contacts', qs.stringify(postData, {
          parseArrays: false
        }))
          .then(response => {
            loader.hide()
            if (response.data.status != 'success') {
              reject(response.data.message);
              return;
            }
            commit('UPDATE_USER_CONTACTS_LOGS', response.data.contactUpdate);
            resolve(response.data);
          })
          .catch(error => console.log(error));
      }
    });
  },
  importUsersCsvFetch({
    commit,
    dispatch
  }, groupId) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/vouchers/import_list/file/' + groupId)
        .then(response => {
          loader.hide()
          console.log(response);
          if (response.data.status != 'success') {
            reject(response.data);
            return;
          }
          commit("SET_IMPORT_USERS_DATA", response.data)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importUsersCSVData({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      var loader
      if (postData.socketValue == false) {
        loader = Vue.$loading.show({
          canCancel: false,
        });
      }
      axios.post('/users/import_user_file', postData.formData)
        .then(response => {
          if (postData.socketValue == false) {
            loader.hide()
          }
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importUsersCopyPasteFetch({
    commit,
    dispatch
  }, groupId) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/vouchers/import_list/text/' + groupId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data);
            return;
          }
          commit("SET_IMPORT_USERS_DATA", response.data)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  uploadUserCompletedPercentage({
    commit,
    dispatch
  }, groupId) {
    return new Promise((resolve, reject) => {
      axios.get('/users/value_check')
        .then(response => {
          console.log(response);
          if (response.data.status != 'success') {
            reject(response.data);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importUsersCopyPasteData({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      var loader
      console.log(postData);
      if (postData.socketValue == false) {
        loader = Vue.$loading.show({
          canCancel: false,
        });
      }
      axios.post('/users/import_text', postData.formData)
        .then(response => {
          if (postData.socketValue == false) {
            loader.hide()
          }
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getUserSetLocation({
    commit,
    dispatch
  }, data) {
    return new Promise((resolve, reject) => {
      axios.get('/users/set_location_list/' + data.id + "/" + data.acc)
        .then(response => {
          if (response.data.status == "redirect") {
            router.push(response.data.message);
          } else {
            if (response.data.status != 'success') {
              reject(response.data);
              return;
            }
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  deleteUserDeviceSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_user_device', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            devId: postData.devId,
            accountId: postData.accountId
          }
          commit('DELETE_USER_DEVICE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
}

const getters = {
  pendingUsersGetters: state => {
    return state.pendingUsers;
  },
  pendingUsersListGetters: state => {
    return state.pendingUsersList;
  },
  presentSessionsDataGetters: state => {
    return state.presentSessionsDataList;
  },
  rejectedUsersGetters: state => {
    return state.rejectedUsersList;
  },
  generateMulitpleUsersGetters: state => {
    return state.generateMultipleUsersList;
  },
  getUserOnuCpeDevicesListGetters: state => {
    return state.viewUserOnuCpeDevicesList;
  },
  getViewUserReferralCodeListGetters: state => {
    return state.viewUserReferralCodeList;
  },
  getUserOverrideBillingCycleListGetters: state => {
    return state.userOverrideBillingCycleList;
  },
  getUserDevicesListGetters: state => {
    return state.userDevicesList;
  },
  getUserSetLocationListGetters: state => {
    return state.userSetLocationList;
  },
  getUserSetLocationPermissionGetters: state => {
    return state.userSetLocationPermission;
  },
  getUserContactsListGetters: state => {
    return state.userContactsList;
  },
  getUserContactsPermissionGetters: state => {
    return state.userContactsPermission;
  },
  getUserWebsiteLogsListGetters: state => {
    return state.userWebsiteLogsList;
  },
  getUserWebsiteLogsPermissionGetters: state => {
    return state.userWebsiteLogsPermission;
  },
  getUserCommentsListGetters: state => {
    return state.userCommentsList;
  },
  getUserCommentsPermissionGetters: state => {
    return state.userCommentsPermission;
  },
  getViewPinsListGetters: state => {
    return state.viewPinsList;
  },
  getViewPinsPermissionGetters: state => {
    return state.viewPinsPermissions;
  },
  getUserPinsListGetters: state => {
    return state.userPinsList;
  },
  getUserPinsPermissionGetters: state => {
    return state.userPinsPermission;
  },
  getUserFranchiseStatementListGetters: state => {
    return state.userFranchiseStatementList;
  },
  getUserFranchiseStatementPermissionGetters: state => {
    return state.userFranchiseStatementPermission;
  },
  getUserLedgerListGetters: state => {
    return state.userLedgerList;
  },
  getUserLedgerPermissionGetters: state => {
    return state.userLedgerPermission;
  },
  getDocumentsListGetters: state => {
    return state.userDocumentsList;
  },
  getDocumentsPermissionGetters: state => {
    return state.userDocumentsPermissions;
  },
  getUserPhoneNumbersListGetters: state => {
    return state.userPhoneNumbersList;
  },
  getUserFupListGetters: state => {
    return state.userFupList;
  },
  getUserFupPermissionGetters: state => {
    return state.userFupPermission;
  },
  getUserTrafficGraphsListGetters: state => {
    return state.userTrafficGraphsList;
  },
  getUserTrafficGraphsPermissionGetters: state => {
    return state.userTrafficGraphsPermission;
  },

  getUserDetailsGetters: state => {

    return state.userDetails;

  }, getUserDataDetailsGetters: state => {

    return state.userDataDetails;

  },
  getRenewalRevertDetailsGetters: state => {
    return state.renewalDetails;
  },
  usersDataListGetters: state => {
    return state.usersDataList;
  },
  groupUserIdGetters: state => {
    return state.groupUserIdData;
  },
  groupRestrictedIdGetters: state => {
    return state.groupRestrictedIdData;
  },
  selectGroupDataGetters: state => {
    return state.selectGroupData;
  },
  packageRouterGetters: state => {
    return state.packageRouterDatas
  },
  usersIndexPermissionGetters: state => {
    return state.usersIndexPermissionData;
  },
  usersRouterDataGetters: state => {
    return state.routerData;
  },
  dummyOrderSubPlanGetters: state => {
    return state.dummyOrderSubPlan
  },
  customizeVocherGetters: state => {
    return state.customizeVouchersData
  },
  addUsersGetter: state => {
    return state.addUserDetails
  },
  editUsersGetter: state => {
    return state.editUserDetails
  },
  viewUsersDetailsGetters: state => {
    return state.viewUserDetails
  },
  getViewUsersTableListGetters: state => {
    return state.viewUsersList
  },
  viewAllUsersDetailsGetters: state => {
    return state.viewAllUserDetails
  },
  getViewAllUsersTableListGetters: state => {
    return state.viewALLUsersList
  },
  viewAllUsersElasticDetailsGetters: state => {
    return state.viewAllUserElasticDetails
  },
  getViewAllUsersElasticTableListGetters: state => {
    return state.viewALLUsersElasticList
  },
  getUserInventoryListGetters: state => {
    return state.userInventoryDetails
  },
  getCafGenerationListGetters: state => {
    return state.cafGenerationData
  },
  sidebarUsersListGetters: state => {
    return state.sideBarUsersList
  },
  importUsersListGetters: state => {
    return state.importUsersData
  },
  importUsersCsvPercentageListGetters: state => {
    return state.usersCsvImportPercent
  },
  importUsersRenewPercentageListGetters: state => {
    return state.usersRenewPercent
  },
  importExpireDatePercentageListGetters: state => {
    return state.expireDatePercent
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
